<div class="generate-otp d-flex">
  <p class="label font14">{{ fileName ?? 'Upload' }}</p>
  <label for="{{ elementId }}" class="btn-primary px-3 button"> Browse </label>
  <input id="{{ elementId }}" class="file-input" type="file" />
</div>
